import axios from '@services/axios'
import { MD5 } from '@utils/lib'

import {
  ILoginZhiNiao,
  ISendVerCodeCaptcha,
  ICheckOpt,
  IBindPhone,
  IPasswordReset,
  IAccountRegistration,
  ILoginAppAndCompany,
  IValidateSafeImgCaptcha,
  ILoginOrRegister,
  IforceLogin,
} from './interface'
import UserStore from '@stores/UserStore'
import Store from 'store'
import { apiConstants, LoginBodyCodeEnum } from '@const/apiConstants'
import { getQueryParams } from '@utils/url'

export * from './interface'

export const isSpecifiedType = (route: string) => {
  const { href } = window.location
  const [_, query] = href.split('?')
  const params = getQueryParams(query) || {}
  return params.route && params.route.includes(route)
}

// 运营人员充值模式
const isTopUpType = isSpecifiedType('/mili-top-up')
const PreFix = '/learn-login/'
const LoginPrefix = '/learn/app/'
const URL = {
  /** 立即报名生成报名二维码接口 */
  GET_APPLY_INFO: `${LoginPrefix}clientapi/home/pc/getApplyInfoById.do`,
  /** 个性化登录配置查询 */
  GET_INDIVIDUAL_LOGIN_INFO: `${LoginPrefix}clientapi/home/pc/getIndividuationLoginInfoByKey.do?individuationKey=`,
  /** 个性化登录长页信息查询 */
  GET_LONG_LOGIN_INFO: `${LoginPrefix}clientapi/home/pc/getIndividuationLoginInfoById.do?pageId=`,
  /** 查询资讯详情 */
  GET_INFO_DETAIL: `${LoginPrefix}/clientapi/home/pc/getInformationDetailById.do?idInformationColumnDetail=`,
  /** 免密登录 */
  LOGIN_REGISTER_WITH_CODE: `${LoginPrefix}clientapi/user/login/loginOrRegisterWithVerCode.do`,
  /** 免密登录查询多独立app身份 */
  QUERY_APP_LIST: `${LoginPrefix}clientapi/user/queryUserAppIdsWithVerCode.do`,
  /** 滑块验证初始化地址 */
  CAPTCHA_REGISTER: `${LoginPrefix}clientapi/user/captcha/register.do?t=${Date.now()}`,
  /** 滑块验证初始化测试地址 */
  CAPTCHA_REGISTER_TEST: 'https://captcha.paic.com.cn/api/demo/slide',
  // login的背景，logoUrl获取
  LOGIN_URL: 'https://captcha.paic.com.cn/api/demo/slide',
  // 免密跳转到智门户
  COMMON_LOGON: `${LoginPrefix}clientapi/user/commonLogin.do`,
  // 校验登录企业是否有权限查看目标知识空间
  CHECK_AUTH: `${LoginPrefix}clientapi/knowledgespace/space/checkAuth.do`,
  // 登录成功后获取账号首次登录及绑定eqx1.0的信息
  CHECK_ACCOUNT: `${LoginPrefix}clientapi/user/getBandAndLoginInfo.do`,
  // 获取敏感词
  SENSITIVE_LIST: `${LoginPrefix}clientapi/misc/sensitiveinfo/queryByPage.do`
}

type FreeLoginParam = {
  userName: string
  verCode: string
  isOpenPlatform: string
}
const loginApis = {
  getCaptchaGt: (type: number): Promise<any> | undefined =>
    axios.get(URL.CAPTCHA_REGISTER, {
      params: { type },
    }),
  getLoginUrl: (): Promise<any> => axios.get(URL.LOGIN_URL),
  queryUserAppIdsWithVerCode: ({
    userName,
    verCode,
    isOpenPlatform = '0',
  }: FreeLoginParam): Promise<any> =>
    axios.post(URL.QUERY_APP_LIST, {
      userName,
      verCode,
      v: 2,
      isRegistered: false,
      isOpenPlatform,
    }),
  getInformationDetailById: (idInformationColumnDetail: string): Promise<any> =>
    axios.get(`${URL.GET_INFO_DETAIL}${idInformationColumnDetail}`),
  getApplyInfoById: (idMlnHomePosterHot: string): Promise<any> =>
    axios.get(`${URL.GET_APPLY_INFO}?idMlnHomePosterHot=${idMlnHomePosterHot}`),
  getIndividuationLoginInfoById: (pageId: string): Promise<any> =>
    axios.get(`${URL.GET_LONG_LOGIN_INFO}${pageId}`),
  getIndividuationLoginInfoByKey(individuationKey: string): Promise<any> {
    return axios.get(`${URL.GET_INDIVIDUAL_LOGIN_INFO}${individuationKey}`, {
      params: {
        noInterceptorCancel: true,
      },
    })
  },
  async loginOrRegisterWithVerCode(data: ILoginOrRegister): Promise<any> {
    const result: any = await axios.post(URL.LOGIN_REGISTER_WITH_CODE, {
      ...data,
      strOs: apiConstants.STR_OS,
      deviceId: MD5(data.userName),
      sourceType: 7,
      terminalChannel: apiConstants.TERMINAL_CHANNEL,
    })
    const { bodyCode } = result.body || {}
    const isLoginAnother = bodyCode === LoginBodyCodeEnum.ACCOUNT_LOGIN_ANOTHER
    const validBodyCode = +bodyCode === 1 || +bodyCode === 5
    const isValid = result.code === 0 && validBodyCode && !isTopUpType
    if (isValid || !isLoginAnother) {
      this.initLoginStore(result.body, data.appId)
    } else {
      this.updateSessionInfo(result.body, data.appId)
    }
    return result
  },
  yztLogin(forceLogin: IforceLogin): Promise<any> {
    return axios.post(`${LoginPrefix}clientapi/user/login/yztLogin.do`, {
      strVer: apiConstants.STR_VER,
      strOs: apiConstants.STR_OS,
      token: forceLogin.token,
      forceKickOut: forceLogin.forceKickOut,
      forceLoginToken: forceLogin.forceLoginToken,
      terminalChannel: apiConstants.TERMINAL_CHANNEL,
    })
  },
  getYZTLgoinUrl(): Promise<any> {
    // 客户端类型,99-智门户,33-安卓,44-ios
    return axios.get(`${LoginPrefix}clientapi/user/yzt/getYZTLgoinUrl.do`)
  },
  yztCallbackForWeb(assert: string): Promise<any> {
    return axios.post(`${LoginPrefix}clientapi/user/yzt/yztCallbackForWeb.do`, {
      assert,
    })
  },
  getSafeImgCaptcha(username: string, randomCode: string): string {
    return `${PreFix}getSafeImgCaptcha.do?userName=${username}&r=${randomCode}`
  },
  // 中车登录
  KXLogin(data: any): Promise<any> {
    return axios.post(`${LoginPrefix}clientapi/user/qingdaosifang/qingDaoSifangAuthLogin.do`, {
      strVer: apiConstants.STR_VER,
      strOs: apiConstants.STR_OS,
      channel: apiConstants.CHANNEL,
      terminalChannel: apiConstants.TERMINAL_CHANNEL,
      ...data
    })
  },

  sendVerCodeCaptcha(data: ISendVerCodeCaptcha): Promise<any> {
    const initState = {
      v: apiConstants.V,
    }
    return axios.post(`${PreFix}sendVerCodeCaptcha.do`, {
      ...initState,
      ...data,
    })
  },

  checkOpt(data: ICheckOpt): Promise<any> {
    return axios.post(`${PreFix}checkOpt.do`, data)
  },
  /** 绑定手机号的入参除了requestType=12（12-账号绑定手机号码并绑定对应的企业身份），其它与IBindePhone接口一致 */
  bindPhoneAndEnterpriseIdentity(data: IBindPhone): Promise<any> {
    return axios.post(
      `/learn/app/clientapi/user/bindPhoneAndEnterpriseIdentity.do`,
      { ...data, requestType: 12 }
    )
  },
  accountRegistration(data: IAccountRegistration): Promise<any> {
    const initState = {
      v: apiConstants.V,
      sourceType: apiConstants.SOURCE_TYPE,
    }
    return axios.post(`${PreFix}accountRegistration.do`, {
      ...initState,
      ...data,
    })
  },

  loginAppAndCompany(data: ILoginAppAndCompany): Promise<any> {
    const initState = {
      v: apiConstants.V,
    }
    return axios.post(`${PreFix}loginAppAndCompany.do`, {
      ...initState,
      ...data,
    })
  },

  // 企业代码登录
  enterpriseLogin(data: any): Promise<any> {
    return axios.post(`${PreFix}clientapi/user/loginByEmpId.do`, {
      ...data,
      v: apiConstants.V,
      appId: data.appId || 'com.mlearning.guangqichuanqi',
      channel: apiConstants.CHANNEL,
      deviceId: MD5(data.empId),
      strVer: apiConstants.STR_VER,
      strOs: apiConstants.STR_OS,
      type: '202',
      forceKickOut: 0,
      forceLoginToken: '',
      terminalChannel: apiConstants.TERMINAL_CHANNEL,
    })
  },

  passwordReset(data: IPasswordReset): Promise<any> {
    const initState = {
      v: apiConstants.V,
    }
    return axios.post(`${PreFix}passwordReset.do`, { ...initState, ...data })
  },

  getUserInfoOld(params: any): Promise<any> {
    return axios.get(`${LoginPrefix}personDetail.do`, { params })
  },
  async loginZhiNiao(data: ILoginZhiNiao): Promise<any> {
    const { CHANNEL, V, VER, STR_VER, STR_OS, TERMINAL_CHANNEL } = apiConstants
    const initState = {
      channel: CHANNEL,
      v: V,
      ver: VER,
      strVer: STR_VER,
      strOs: STR_OS,
      terminalChannel: TERMINAL_CHANNEL,
    }
    const result: any = await axios.post(`${PreFix}loginZhiNiao.do`, {
      ...initState,
      ...data,
    })
    const { bodyCode } = result.body || {}
    const isLoginAnother = bodyCode === LoginBodyCodeEnum.ACCOUNT_LOGIN_ANOTHER
    const validBodyCode = +bodyCode === 1 || +bodyCode === 5
    const isValid = result.code === 0 && validBodyCode && !isTopUpType
    if (isValid || !isLoginAnother) {
      this.initLoginStore(result.body, data.appId)
    } else {
      this.updateSessionInfo(result.body, data.appId)
    }
    return result
  },

  validateSafeImgCaptcha(data: IValidateSafeImgCaptcha): Promise<any> {
    const initState = {
      ver: apiConstants.VER,
    }
    return axios.post(`${PreFix}validateSafeImgCaptcha.do`, {
      ...initState,
      ...data,
    })
  },

  h5pluginForApp(data: string): Promise<any> {
    return axios.get(`/learn/app/h5pluginForApp.do${data}`)
  },

  h5plugin(data: string): Promise<any> {
    return axios.get(`/learn/app/h5plugin.do${data}`)
  },

  // eslint-disable-next-line @typescript-eslint/ban-types
  sidIsEffective(appId = 'com.mlearning.guangqichuanqi', params?: {}): Promise<any> {
    const data = {
      ver: apiConstants.VER,
      v: apiConstants.V,
      strVer: apiConstants.STR_VER,
      channel: apiConstants.CHANNEL,
      strOs: apiConstants.STR_OS,
      appId, // 获取拓展再改
      terminalChannel: apiConstants.TERMINAL_CHANNEL,
      ...params
    }
    return axios.post(`${PreFix}sidIsEffective.do`, data)
  },

  getUserInfo(): Promise<any> {
    return axios.get(`${LoginPrefix}newPersonDetail.do`)
  },
  logout(): Promise<any> {
    return axios.post(`${LoginPrefix}loginOut.do`)
  },

  refreshSid(): Promise<any> {
    return axios.get(`${PreFix}refreshSid.do`)
  },
  /** 获取增值服务列表 */
  queryOperationList(): Promise<any> {
    return axios.get(
      `${LoginPrefix}clientapi/home/ai/operationPermission/queryOperationList.do`
    )
  },
  updateSessionInfo: (
    res: {
      enterpriseId: string
      enterpriseName: string
      sid: string
      userId: string
    },
    appId: string
  ) => {
    const { enterpriseId, enterpriseName, sid, userId } = res
    Store.set('sessionInfo', {
      enterpriseId,
      enterpriseName,
      sid,
      userId,
      appId,
    })
    window.sessionStorage.setItem('__zn__sid', sid)
  },
  async initLoginStore(
    res: {
      enterpriseId: string
      enterpriseName: string
      sid: string
      userId: string
    },
    appId: string
  ) {
    const { enterpriseId, enterpriseName, sid, userId } = res
    console.log(999)
    UserStore.updateLoginInfo(enterpriseId, enterpriseName, sid, userId, appId)

    const params = {
      isSupportAudioLive: 1,
      ver: apiConstants.V,
      umId: userId,
      appId,
      searchedUserId: userId,
      sid,
    }
    const oldAppUserInfo = await this.getUserInfoOld(params)
    if (oldAppUserInfo && oldAppUserInfo.body) {
      Store.set('oldAppUserInfo', oldAppUserInfo.body)
    }
  },
  singleLoginKnowledgeCloud(params: any): Promise<any> {
    return axios.get(URL.COMMON_LOGON, { params })
  },
  checkAuth(params: any): Promise<any> {
    return axios.get(URL.CHECK_AUTH, { params })
  },
  checkEnterpriseCode(data: any): Promise<any> {
    return axios.post(`${PreFix}clientapi/user/checkEnterpriseCode.do`,
      {
        customEnterpriseCode: data.customEnterpriseCode
      },
      {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }
    )
  },
  // 智门户登录
  loginUrl(params: any): Promise<any> {
    return axios.get(`${PreFix}clientapi/user/oauth/loginUrl.do`, { params })
  },
  // 登录成功后获取账号首次登录及绑定eqx1.0的信息
  checkAccount(): Promise<any> {
    return axios.get(URL.CHECK_ACCOUNT)
  },
  // 获取敏感词
  getSensitiveList: (params: any): Promise<any> => {
    return axios.post(`${URL.SENSITIVE_LIST}`, params, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
    })
  }
}

export default loginApis
